import { useState, useEffect, useCallback } from "react";
import { chatAPI } from "../services/chatAPI";
import socketService from "../services/socketService";
import { playNotificationSound } from "../utils/playNotificationSound";


const getUserModelFromData = (userData) => {
  if (!userData) return null;
  if (userData.client_name) return "clients";
  if (userData.department) return "staff";
  if (userData.email) return "admin";
  return null;
};



export const useChatUnreadIndicator = (userData) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const userModel = getUserModelFromData(userData);

  const loadCount = useCallback(async () => {
    if (!userData?._id || !userModel) return;
    try {
      const res = await chatAPI.getUnreadCount(userData._id, userModel);
      if (res?.success) {
        setUnreadCount(res.data?.unread_count || 0);
      } else {
        setUnreadCount(0);
      }
    } catch (error) {
      setUnreadCount(0);
    }
  }, [userData?._id, userModel]);

  const markChatsAsRead = async () => {
    if (!userData?._id || !userModel) return;

    // ✅ backend update
    // await chatAPI.markAllChatsAsRead(userData._id, userModel);

    try {
      await chatAPI.markAllChatNotifications(userData._id, userModel);
    } catch (error) {
      // Keep UI stable if chat API is unavailable
    }


    // ✅ frontend realtime update
    setUnreadCount(0);
  };

 useEffect(() => {
  if (!userData?._id || !userModel) return;

  const socket = socketService.connect({
    userId: userData._id,
    userModel,
  });

  const handleNewNotification = async () => {
    try {
      await loadCount(); // always fetch real count
      playNotificationSound();
    } catch (error) {
      // Ignore socket-triggered fetch errors
    }
  };

  // 🔥 Remove any previous listeners first
  socketService.offNewNotification(handleNewNotification);

  // 🔥 Attach ONLY ONCE
  socketService.onNewNotification(handleNewNotification);

  loadCount();

  return () => {
    socketService.offNewNotification(handleNewNotification);
  };

}, [userData?._id, userModel]);



  return {
    unreadCount,
    markChatsAsRead,   // 🔥 EXPOSE THIS
  };
};

